import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';
import { Options } from '@/components/Common/Selects/Select.types';

type LeconText = {
  html?: string;
  text?: string;
};

export type LessonFormValues = {
  title?: string;
  classe?: Options[];
  serie?: Options[];
  discipline?: string;
  summary?: LeconText;
  longContent?: LeconText;
  audio?: File;
  picture?: File;
};

const lessonValidationSchema = (mode: 'create' | 'update') =>
  yup.object({
    title: yup.string().required('Le titre est obligatoire'),
    summary: yup
      .object({
        html: yup.string().required('Une Leçon doit avoir un resumé'),
        text: yup.string().required('Une Leçon doit avoir un resumé'),
      })
      .required('Une Leçon doit avoir un resumé'),
    longContent: yup
      .object({
        html: yup.string().required('Une Leçon doit avoir un contenu'),
        text: yup.string().required('Une Leçon doit avoir un contenu'),
      })
      .required('Une Leçon doit avoir un contenu'),
    discipline: yup.string().required('La discipline est obligatoire'),
    classe: yup
      .array()
      .of(
        yup.object().shape({
          _id: yup.string().required(),
          name: yup.string().required(),
        }),
      )
      .min(1, 'Veuillez sélectionner au moins une classe.')
      .required('La classe est obligatoire'),
    serie: yup
      .array()
      .of(
        yup.object().shape({
          _id: yup.string().required(),
          name: yup.string().required(),
        }),
      )
      .min(1, 'Veuillez sélectionner au moins une série.')
      .required('La série est obligatoire'),
    audio: yup.mixed<File>().when([], {
      is: () => mode === 'create',
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.notRequired(),
    }),
    picture: yup.mixed<File>().when([], {
      is: () => mode === 'create',
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

export const useHandleLessonForm = (mode: 'create' | 'update') => {
  const { register, handleSubmit, errors, setValue, reset, trigger, control } =
    useFormHandler<LessonFormValues>(lessonValidationSchema(mode));
  return {
    register,
    handleSubmit,
    setValue,
    errors,
    reset,
    trigger,
    control,
  };
};
